import React, { useEffect, useState, memo } from 'react';
import PropTypes from 'prop-types';

import EnvironmentInfo from './EnvironmentInfo/EnvironmentInfo';
import { AreaEnvironment, Column } from 'components/common/charts/charts';
import { Loading, PageSubTitle } from 'components/common/Elements/Elements';

import { postRequest } from 'utils/requests';

import classes from './Environment.module.scss';

const Environment = ({ customerId }) => {
  const [environmentData, setEnvironmentData] = useState({});
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    let cancelled = false;
    window.scrollTo(0, 0);
    postRequest('/customer/environment', {
      customerId: customerId
    })
      .then(res => {
        if (!cancelled) {
          setEnvironmentData({ customerId, ...res.body });
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          console.log(err);
          setLoader(false);
        }
      });
    return () => (cancelled = true);
  }, [customerId]);

  if (loader) {
    return <Loading />;
  }

  return (
    <>
      <PageSubTitle hiden title="Environment Informaton" />
      <div className={classes.environment}>
        <EnvironmentInfo environmentData={environmentData} />
        <div className={classes.charts}>
          <AreaEnvironment chartData={environmentData.licenseUtilization} />
          <Column chartData={environmentData.accountUsage} />
        </div>
      </div>
    </>
  );
};

Environment.propTypes = {
  customerId: PropTypes.string
};

export default memo(Environment);
